import { render, staticRenderFns } from "./costAdAction.vue?vue&type=template&id=8c453a08&scoped=true"
import script from "./costAdAction.vue?vue&type=script&lang=js"
export * from "./costAdAction.vue?vue&type=script&lang=js"
import style0 from "./costAdAction.vue?vue&type=style&index=0&id=8c453a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c453a08",
  null
  
)

export default component.exports